import { useId } from 'react';

type Props = {
  className?: string;
  /** Width in CSS pixels. Height follows the pointy-top hex ratio. */
  size?: number;
};

/**
 * AD / 12 crest — black pointy hex, thin gold stroke, stacked gold type.
 * Matches the authored badge (not the inverted gold-fill mark).
 */
export function AdHexMark({ className, size = 45 }: Props) {
  const uid = useId().replace(/:/g, '');
  const gold = `adHexGold-${uid}`;

  return (
    <svg
      className={className}
      width={size}
      height={size * (92 / 80)}
      viewBox="0 0 80 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id={gold} x1="40" y1="8" x2="40" y2="84" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#F2D56B" />
          <stop offset="42%" stopColor="#D4AF37" />
          <stop offset="100%" stopColor="#9A6F12" />
        </linearGradient>
      </defs>
      <polygon
        points="40,10 71.2,28 71.2,64 40,82 8.8,64 8.8,28"
        fill="#050505"
        stroke={`url(#${gold})`}
        strokeWidth="1.4"
        strokeLinejoin="miter"
      />
      <text
        x="40"
        y="44"
        textAnchor="middle"
        fill={`url(#${gold})`}
        fontFamily="'Barlow Condensed', Oswald, 'Arial Narrow', sans-serif"
        fontWeight="800"
        fontSize="28"
        letterSpacing="0.2"
        style={{ fontFamily: "'Barlow Condensed', Oswald, sans-serif" }}
      >
        AD
      </text>
      <text
        x="40"
        y="64"
        textAnchor="middle"
        fill={`url(#${gold})`}
        fontFamily="'Barlow Condensed', Oswald, 'Arial Narrow', sans-serif"
        fontWeight="700"
        fontSize="14"
        letterSpacing="1.6"
        style={{ fontFamily: "'Barlow Condensed', Oswald, sans-serif" }}
      >
        12
      </text>
    </svg>
  );
}
